import { render, staticRenderFns } from "./Ldwgc.vue?vue&type=template&id=7d20f99c&scoped=true&"
import script from "./Ldwgc.vue?vue&type=script&lang=js&"
export * from "./Ldwgc.vue?vue&type=script&lang=js&"
import style0 from "./Ldwgc.vue?vue&type=style&index=0&id=7d20f99c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d20f99c",
  null
  
)

export default component.exports